import React from "react";
// import motion
import { motion } from "framer-motion";
import { fadeIn } from "../variants";

const Copyright = () => {
  return (
    <div className="bg-dark text-[#dbdbdb] py-6 border-t border-[#2b2b2b]">
      <div className="container mx-auto">
        <motion.div
          initial={{ y: 40, opacity: 0 }}
          whileInView={{ y: 0, opacity: 1 }}
          variants={fadeIn("right")}
          transition={{
            type: "tween",
            duration: 0.8,
            delay: 0.2,
          }}
          viewport={{ once: false, amount: 0.2 }}
          className="tracking-[0.02em] text-base text-center"
        >
          &copy; 2026{" "}
          <span className="font-semibold text-white">Babapiercing.</span> Minden
          jog fenttartva.
          <span className="mx-2 text-[#4b4b4b]">|</span>
          <span className="text-sm">
            Készítette: <a href="https://szombath-robert-portfolio.vercel.app/" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-all duration-300">Sz_R</a>
          </span>
        </motion.div>
      </div>
    </div>
  );
};

export default Copyright;
